import { cookies } from '@/shared/utils/cookies';
import { HeaderLazy } from './Header.lazy';
import { PORTAL_COOKIE } from '@/shared/constants/constants';
import { HeaderDSLazy } from './HeaderDS.lazy';
import { isMobileDevice } from '@/shared/utils/check-mobile-device';

export const HeaderProcess = () => {
    const Component = cookies.getCookie(PORTAL_COOKIE) === '1' && isMobileDevice ? HeaderDSLazy : HeaderLazy;
    return <Component/>;
};
